import { useSelector } from 'react-redux';
import { validationSchemaAccount } from './validationSchema';
import { Form, Formik } from 'formik';
import { TextArea, TextBox } from '../../shared/controls/form';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import SelectBox from '../../shared/controls/form/selectBox';
import apiServices from '../../services/service';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import { formatUSCurrency } from '../../shared/constants';

const AccountForm = ({
  formData,
  handleSubmit,
  selectedOptions,
  handleChange,
  handleChangeForm,
  errormsg,
}) => {
  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));

  const accountType = useSelector(getGenericMasterFilteredListByKey('AccountType'));
  const owner = useSelector(getActiveOwners);

  const {
    options: accountOptions,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown,
    responseKey: 'accountList',
  });

  return (
    <Formik
      initialValues={formData}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={validationSchemaAccount}
    >
      <Form>
        <div className="collapse_card">
          <div className={formData?.type === 'view' ? 'addleadcard-view' : 'addleadcard'}>
            <div className="row gx-3">
              <div className="col-12 col-sm-12 col-md-7">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/contactInfo.svg" alt="" />
                      Account Information
                    </label>
                  </div>

                  <div
                    className={
                      formData?.industry === 'Healthcare'
                        ? 'leadcontent pd_card leadDetailInfo accountHtB'
                        : 'leadcontent pd_card leadDetailInfo accountHtA'
                    }
                  >
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <TextBox
                            isRequired={true}
                            label={'Account Name'}
                            name={'name'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Account Name'}
                            value={formData?.name}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.name}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Account Type'}
                            name={'accountTypeId'}
                            selectedOptions={selectedOptions?.accountTypeId}
                            handleSelect={handleChange}
                            options={accountType}
                            disabled={formData?.type === 'view'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.accountType || '--'
                                : formData?.accountType || 'Select Account Type'
                            }
                            optionKeys={['id', 'displayName']}
                            errormsg={errormsg?.accountTypeId}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <SelectBox
                            label={'Parent Account'}
                            name={'parentAccountId'}
                            placeholder={
                              formData?.type === 'view'
                                ? formData?.parentAccount || '--'
                                : formData?.parentAccount || 'Select Parent Account'
                            }
                            selectedOptions={selectedOptions?.parentAccountId}
                            handleSelect={handleChange}
                            disabled={formData?.type === 'view'}
                            options={accountOptions?.filter(
                              (account) => account.id !== formData?.id
                            )}
                            optionKeys={['id', 'name']}
                            errormsg={errormsg?.parentAccountId}
                            isLoading={isAccountLoading}
                            onSearch={handleAccountSearch}
                            onScrollToBottom={handleAccountScroll}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <TextBox
                            label={'Phone'}
                            name={'phone'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Phone Number'}
                            value={formData?.phone}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.phone}
                            maxLength={15}
                            disabled={formData?.type === 'view'}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <TextBox
                            label={'Alternate Phone'}
                            name={'alternatePhone'}
                            placeholder={
                              formData?.type === 'view' ? '--' : 'Enter Alternate Phone Number'
                            }
                            value={formData?.alternatePhone}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.alternatePhone}
                            disabled={formData?.type === 'view'}
                            fieldType="phone"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container LinkDes">
                          <TextBox
                            label={'Company LinkedIn'}
                            name={'companyLinkedIn'}
                            placeholder={
                              formData?.type === 'view' ? '--' : "Enter Company's Linkedin"
                            }
                            value={formData?.companyLinkedIn}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.companyLinkedIn}
                            disabled={formData?.type === 'view'}
                            fieldType="link"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container LinkDes">
                          <TextBox
                            label={'Website'}
                            name={'website'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Website'}
                            value={formData?.website}
                            handleChange={handleChangeForm}
                            maxLength={250}
                            errormsg={errormsg?.website}
                            disabled={formData?.type === 'view'}
                            fieldType="link"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <TextBox
                            label={'Employees'}
                            name={'employees'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Employees'}
                            value={formData?.employees}
                            handleChange={handleChangeForm}
                            errormsg={errormsg?.employees}
                            disabled={formData?.type === 'view'}
                            maxLength={10}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12">
                        <div className="input-container">
                          <TextBox
                            // fieldClass={"dollarValue"}
                            label={'Annual Revenue'}
                            name={'annualRevenue'}
                            placeholder={formData?.type === 'view' ? '--' : 'Enter Annual Revenue'}
                            value={
                              formData?.type === 'view'
                                ? formatUSCurrency(formData?.annualRevenue)
                                : (formData?.annualRevenue ?? '')
                            }
                            handleChange={handleChangeForm}
                            maxLength={16}
                            errormsg={errormsg?.annualRevenue}
                            disabled={formData?.type === 'view'}
                          />
                        </div>
                      </div>
                      {formData?.industry === 'Healthcare' && (
                        <div className="col-12 col-md-9">
                          <div className="input-container">
                            <TextBox
                              label={'Number of Beds'}
                              name={'noOfBeds'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Number of Beds'
                              }
                              value={formData?.noOfBeds}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.noOfBeds}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-5">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="infoBox">
                      <div className="addlead-header pd_card">
                        <label htmlFor="" className="flex-div align-items-center">
                          <img className="me-2" src="../assets/images/companyInfo.svg" alt="" />
                          General Information
                        </label>
                      </div>
                      <div className="leadcontent pd_card leadDetailInfo leadHt">
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <SelectBox
                                  label={'Industry'}
                                  name={'industryId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.industry || '--'
                                      : formData?.industry || 'Select Industry'
                                  }
                                  // isRequired={true}
                                  disabled={formData?.type === 'view'}
                                  selectedOptions={selectedOptions?.industryId}
                                  handleSelect={handleChange}
                                  options={industryTypeDropdown}
                                  optionKeys={['id', 'displayName']}
                                  errormsg={errormsg?.industryId}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <SelectBox
                                  label={'Account Owner'}
                                  name={'ownerId'}
                                  placeholder={
                                    formData?.type === 'view'
                                      ? formData?.owner || '--'
                                      : formData?.owner || 'Select Account Owner'
                                  }
                                  // isRequired={true}
                                  disabled={formData?.type === 'view'}
                                  selectedOptions={selectedOptions.ownerId}
                                  handleSelect={handleChange}
                                  options={owner}
                                  optionKeys={['userId', 'userName']}
                                  errormsg={errormsg?.ownerId}
                                  nameFormatter={true}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12">
                    <div className="infoBox">
                      <div className="addlead-header pd_card">
                        <label htmlFor="" className="flex-div align-items-center">
                          <img className="me-2" src="../assets/images/addressInfo.svg" alt="" />
                          Address Information
                        </label>
                      </div>
                      <div
                        className={
                          formData?.industry === 'Healthcare'
                            ? 'leadcontent pd_card leadDetailInfo accountHt2'
                            : 'leadcontent pd_card leadDetailInfo accountHt0'
                        }
                      >
                        <>
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Street'}
                                  name={'street'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Street'}
                                  value={formData?.street}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.street}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'City'}
                                  name={'city'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter City'}
                                  value={formData?.city}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.city}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'State'}
                                  name={'state'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter State'}
                                  value={formData?.state}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.state}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Zip Code'}
                                  name={'zipCode'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Zip Code'}
                                  value={formData?.zipCode}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.zipCode}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12">
                              <div className="input-container">
                                <TextBox
                                  label={'Country'}
                                  name={'country'}
                                  placeholder={formData?.type === 'view' ? '--' : 'Enter Country'}
                                  value={formData?.country}
                                  handleChange={handleChangeForm}
                                  maxLength={250}
                                  errormsg={errormsg?.country}
                                  disabled={formData?.type === 'view'}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="infoBox">
                  <div className="addlead-header pd_card">
                    <label htmlFor="" className="flex-div align-items-center">
                      <img className="me-2" src="../assets/images/notesIcon.svg" alt="" />
                      Notes & Tech Details
                    </label>
                  </div>
                  <div className="leadcontent pd_card leadDetailInfo notesLabel">
                    <>
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Description'}
                              name={'description'}
                              placeholder={formData?.type === 'view' ? '--' : 'Enter Description'}
                              value={formData?.description}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.description}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6">
                          <div className="input-container blockClass">
                            <TextArea
                              label={'Technology Details'}
                              name={'technologyDetails'}
                              placeholder={
                                formData?.type === 'view' ? '--' : 'Enter Technology Details'
                              }
                              value={formData?.technologyDetails}
                              handleChange={handleChangeForm}
                              errormsg={errormsg?.technologyDetails}
                              disabled={formData?.type === 'view'}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default AccountForm;
